import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import store from './store/index'
import ElementUI from 'element-ui' 

Vue.use(ElementUI)
import { Button as button, Image as VanImage, Tabs, Tab, Toast, Icon, List, DropdownMenu, DropdownItem, Checkbox,
   CheckboxGroup, Rate, SwipeCell, AddressEdit, Field, IndexBar, IndexAnchor } from 'vant'

import { Button, Input, Carousel, CarouselItem, Tooltip, Rate as el_rate, Progress, Message, Card, Radio, Table, TableColumn, Select, } from 'element-ui'
// el-rate
import jQuery from 'jquery'
import router from './router'
import service from './utils/request'
import { getParam } from './utils/url'
import VueClipboard from 'vue-clipboard2'

// import './style/font.less'
import 'vant/lib/index.css';
import 'element-ui/lib/theme-chalk/index.css'
// 控制台
// import eruda from 'eruda'

// eruda.init();


//element
Vue.use(Button)
   .use(Input)
   .use(Select)
   .use(Carousel)
   .use(CarouselItem)
   .use(Tooltip)
   .use(el_rate)
   .use(Progress)
   .use(Card)
   .use(Radio)
   .use(Table)
   .use(TableColumn)
//vant
Vue.use(Tabs)
   .use(Tab)
   .use(Toast)
   .use(Icon)
   .use(List)
   .use(DropdownMenu)
   .use(DropdownItem)
   .use(Checkbox)
   .use(CheckboxGroup)
   .use(Rate)
   .use(SwipeCell)
   .use(button)
   .use(AddressEdit)
   .use(Field)
   .use(IndexBar)
   .use(IndexAnchor)
  //  .use(VanImage)


Vue.use(VueRouter)
Vue.use(VueClipboard)
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Date.prototype.format = function(fmt) {
    var o = {
        "M+" : this.getMonth()+1,                 //月份
        "d+" : this.getDate(),                    //日
        "h+" : this.getHours(),                   //小时
        "m+" : this.getMinutes(),                 //分
        "s+" : this.getSeconds(),                 //秒
        "q+" : Math.floor((this.getMonth()+3)/3), //季度
        "S"  : this.getMilliseconds()             //毫秒
    };
    if(/(y+)/.test(fmt)) {
            fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
    }
    for(var k in o) {
      if(new RegExp("("+ k +")").test(fmt)){
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
        }
    }
    return fmt;
}



window.getParam = getParam
Vue.prototype.$=jQuery
Vue.prototype.$axios= service
Vue.prototype.$message = Message;
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
